import React from "react";
import SectionLabel from "@/components/SectionLabel";

const COPY = {
  privacy: {
    label: "PRIVACY POLICY",
    title: "Privacy Policy",
    body: [
      "Nijah Almond LLC (“we,” “us,” “our”) operates nijahalmond.com (the “Site”). This page informs you of our policies regarding the collection, use, and disclosure of personal information we receive from users of the Site.",
      "Information we collect: We collect information you voluntarily provide — such as name, email, and message content — when you sign up for the newsletter, request the free guide, or submit the contact form.",
      "How we use it: To deliver the resources you request, respond to your inquiries, and (if you opted in) send periodic updates. We do not sell your information.",
      "Email opt-out: Every email we send includes an unsubscribe link. You can opt out at any time.",
      "Data security: We use reasonable safeguards to protect your information. No method of transmission over the Internet is 100% secure.",
      "Contact: For privacy questions, email info@nijahalmond.com.",
    ],
  },
  terms: {
    label: "TERMS OF SERVICE",
    title: "Terms of Service",
    body: [
      "By accessing nijahalmond.com you agree to these Terms. If you don’t agree, please do not use the Site.",
      "Use of content: All content — text, frameworks, design, GRIT™ — is the intellectual property of Nijah Almond LLC. You may share with attribution; you may not reproduce or resell.",
      "Coaching services: Coaching is a professional, educational service. It is not therapy, medical advice, or a substitute for licensed care.",
      "Payments &amp; refunds: Specific refund and cancellation terms are provided in your individual coaching agreement.",
      "Updates: We may update these Terms from time to time. Continued use of the Site means you accept the updates.",
    ],
  },
  disclaimer: {
    label: "DISCLAIMER",
    title: "Disclaimer",
    body: [
      "The information on nijahalmond.com is for general informational and educational purposes only.",
      "Nothing on this Site constitutes medical, legal, financial, or therapeutic advice. Coaching is not a replacement for professional therapy or medical care. Please consult licensed professionals for those needs.",
      "Results from coaching vary. Testimonials reflect individual experiences and are not guarantees of similar outcomes.",
      "External links: We sometimes link to third-party sites for convenience. We are not responsible for content on those sites.",
    ],
  },
};

const Legal = ({ kind = "privacy" }) => {
  const c = COPY[kind];
  return (
    <div data-testid={`page-legal-${kind}`}>
      <section style={{ background: "var(--teal)", color: "#fff", padding: "120px 0 60px" }}>
        <div className="container-x" style={{ maxWidth: 800 }}>
          <SectionLabel gold>{c.label}</SectionLabel>
          <h1 className="h-display" style={{ fontSize: "clamp(40px, 5vw, 64px)", color: "#fff", marginTop: 14 }}>
            {c.title}
          </h1>
          <p style={{ marginTop: 14, color: "rgba(255,255,255,.6)", fontSize: 12, letterSpacing: 1, textTransform: "uppercase" }}>
            Last updated: April 2026
          </p>
        </div>
      </section>
      <section className="section-pad bg-cream">
        <div className="container-x" style={{ maxWidth: 760 }}>
          {c.body.map((p, i) => (
            <p key={i} className="body-base" style={{ marginBottom: 16 }} dangerouslySetInnerHTML={{ __html: p }} />
          ))}
          <p className="body-base" style={{ marginTop: 24, fontSize: 13, color: "rgba(13,31,36,.55)" }}>
            Questions? Email <a href="mailto:info@nijahalmond.com" style={{ color: "var(--teal)" }}>info@nijahalmond.com</a>.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Legal;
